var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadminton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99258 18.8504C1.5117 18.3862 1.57113 17.6013 2.11647 17.2142L5.14283 15.0657C5.3194 14.9403 5.56154 14.9629 5.71166 15.1188C5.85633 15.2689 5.87396 15.5001 5.75374 15.6703L3.61554 18.698C3.23649 19.2348 2.46565 19.3071 1.99258 18.8504Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58337 11.2348L5.83337 14.9848",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.191 11.2993C14.6117 12.8786 11.5575 12.9456 9.71512 11.1031C7.87263 9.26067 7.9396 6.20647 9.51887 4.62722C11.5934 2.5527 15.4979 1.63537 17.3404 3.47782C19.1829 5.32028 18.2655 9.22483 16.191 11.2993Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default __webpack_public_path__ + "static/media/badminton.162bd8bda2275843eb6fa6aa8ae2c6e7.svg";
export { ForwardRef as ReactComponent };